import {
  CommentType,
  CommentsMode,
  CommentsViewTypeEnum,
  PartialCommentType,
  PostGetCommentType,
  PostType,
  PostUploadType,
} from 'types/postTypes';

import {
  CHANGE_UPLOAD_POST_FILE,
  CLEAR_CURRENT_REPOST,
  CLEAR_EDITING_POST,
  CREATE_POST,
  CREATE_POST_FAILED,
  CREATE_POST_SUCCESS,
  DELETE_COMMENT,
  DELETE_COMMENT_FAILED,
  DELETE_COMMENT_SUCCESS,
  DELETE_POST,
  DELETE_POST_FAILED,
  DELETE_POST_SUCCESS,
  GET_COMMENTS,
  GET_COMMENTS_FAILED,
  GET_COMMENTS_SUCCESS,
  GET_POST,
  GET_POSTS,
  GET_POSTS_FAILED,
  GET_POSTS_SUCCESS,
  GET_POST_COMMENT_WS,
  GET_POST_COMMENT_WS_FAILED,
  GET_POST_COMMENT_WS_SUCCESS,
  GET_POST_FAILED,
  GET_POST_SUCCESS,
  LIKE_COMMENT,
  LIKE_COMMENT_FAILED,
  LIKE_COMMENT_SUCCESS,
  LIKE_POST,
  LIKE_POST_FAILED,
  LIKE_POST_SUCCESS,
  LINK_FILES,
  LINK_FILES_FAILED,
  LINK_FILES_SUCCESS,
  POST_COMMENT,
  POST_COMMENT_FAILED,
  POST_COMMENT_SUCCESS,
  SET_CURRENT_REPOST,
  SET_EDITING_POST,
  SET_NTF_STATUS,
  SET_NTF_STATUS_FAILED,
  SET_NTF_STATUS_SUCCESS,
  UNLINK_FILES,
  UNLINK_FILES_FAILED,
  UNLINK_FILES_SUCCESS,
  UPDATE_COMMENT,
  UPDATE_COMMENT_FAILED,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_WS,
  UPDATE_POST,
  UPDATE_POST_FAILED,
  UPDATE_POST_SUCCESS,
  UPLOAD_POST_FILE,
  UPLOAD_POST_FILE_FAILED,
  UPLOAD_POST_FILE_SUCCESS,
} from '../constants';

import { FileDescriptor, MediaTypes } from 'types/fileTypes';
import { ActionType } from 'types/reduxTypes';

export type GetPostsRequestType = {
  asc?: boolean;
  pageSize?: number;
  sinceDateTime?: string;
  isAppend?: boolean;
};

export type GetPostsSuccessType = { posts: PostType[]; isAppend?: boolean; hasMore: boolean };
export type GetCommentsSuccessType = {
  comments: CommentType[];
  isAppend?: boolean;
  hasMore: boolean;
  commentId?: string;
  mode: CommentsMode;
};

export type UpdatePostType = {
  post: PostType;
  filesToRemove: FileDescriptor[];
  files: FileDescriptor[];
};

export type GetCommentsRequestType = {
  postId: string;
  view?: CommentsViewTypeEnum;
  up?: string;
  pageSize?: number;
  sinceDateTime?: string;
  asc?: boolean;
  isAppend?: boolean;
  mode?: CommentsMode;
};

export type LikeCommentRequestType = { commentId: string; actionType: 'like' | 'dislike' };
export type UpdateCommentRequestType = { commentId: string; reaction_count: number };
export type NtfCommentsRequestType = { uref: string; ntfStatus: boolean };
export type GetPostCommentRequestType = { uref: string; ntfStatus: boolean };
export type UploadFileType = { formData: FormData; fileInfo: { fileType: MediaTypes }[] };
export type LikePostRequestType = { postId: string; actionType: 'like' | 'dislike' };

export function clearEditingPost(): { type: string } {
  return {
    type: CLEAR_EDITING_POST,
  };
}

export function setEditingPost(payload: PostType): ActionType {
  return {
    payload,
    type: SET_EDITING_POST,
  };
}

export function createPost(payload: PostUploadType): ActionType {
  return {
    payload,
    type: CREATE_POST,
  };
}

export function createPostSuccess(payload: unknown): ActionType {
  return {
    payload,
    type: CREATE_POST_SUCCESS,
  };
}

export function createPostFailed(payload: unknown): ActionType {
  return {
    payload,
    type: CREATE_POST_FAILED,
  };
}

export function updatePost(payload: UpdatePostType): ActionType {
  return {
    payload,
    type: UPDATE_POST,
  };
}

export function updatePostSuccess(payload: PostType): ActionType {
  return {
    payload,
    type: UPDATE_POST_SUCCESS,
  };
}

export function updatePostFailed(payload: unknown): ActionType {
  return {
    payload,
    type: UPDATE_POST_FAILED,
  };
}

export function deletePost(payload: string): ActionType {
  return {
    payload,
    type: DELETE_POST,
  };
}

export function deletePostSuccess(payload: string): ActionType {
  return {
    payload,
    type: DELETE_POST_SUCCESS,
  };
}

export function deletePostFailed(payload: unknown): ActionType {
  return {
    payload,
    type: DELETE_POST_FAILED,
  };
}

export function getPost(payload: string): ActionType {
  return {
    payload,
    type: GET_POST,
  };
}

export function getPostSuccess(payload: { post: PostType }): ActionType {
  return {
    payload,
    type: GET_POST_SUCCESS,
  };
}

export function getPostFailed(payload: unknown): ActionType {
  return {
    payload,
    type: GET_POST_FAILED,
  };
}

export function getPosts(payload: GetPostsRequestType): ActionType {
  return {
    payload,
    type: GET_POSTS,
  };
}

export function getPostsSuccess(payload: GetPostsSuccessType): ActionType {
  return {
    payload,
    type: GET_POSTS_SUCCESS,
  };
}

export function getPostsFailed(payload: unknown): ActionType {
  return {
    payload,
    type: GET_POSTS_FAILED,
  };
}

export function setCurrentRepost(payload: { repost: PostType }): ActionType {
  return {
    payload,
    type: SET_CURRENT_REPOST,
  };
}

export function clearCurrentRepost(): { type: string } {
  return {
    type: CLEAR_CURRENT_REPOST,
  };
}

export function uploadPostFile(payload: unknown): ActionType {
  return {
    payload,
    type: UPLOAD_POST_FILE,
  };
}

export function uploadPostFileSuccess(payload: unknown): ActionType {
  return {
    payload,
    type: UPLOAD_POST_FILE_SUCCESS,
  };
}

export function uploadPostFileFailed(payload: unknown): ActionType {
  return {
    payload,
    type: UPLOAD_POST_FILE_FAILED,
  };
}

export function changeUploadPostFile(payload: unknown): ActionType {
  return {
    payload,
    type: CHANGE_UPLOAD_POST_FILE,
  };
}

export function linkFiles(payload: unknown): ActionType {
  return {
    payload,
    type: LINK_FILES,
  };
}

export function linkFilesFailed(payload: unknown): ActionType {
  return {
    payload,
    type: LINK_FILES_FAILED,
  };
}

export function linkFilesSuccess(payload: unknown): ActionType {
  return {
    payload,
    type: LINK_FILES_SUCCESS,
  };
}

export function unlinkFiles(payload: unknown): ActionType {
  return {
    payload,
    type: UNLINK_FILES,
  };
}

export function unlinkFilesFailed(payload: unknown): ActionType {
  return {
    payload,
    type: UNLINK_FILES_FAILED,
  };
}

export function unlinkFilesSuccess(payload: unknown): ActionType {
  return {
    payload,
    type: UNLINK_FILES_SUCCESS,
  };
}

export function getComments(payload: GetCommentsRequestType): ActionType {
  return {
    payload,
    type: GET_COMMENTS,
  };
}

export function getCommentsFailed(payload: unknown): ActionType {
  return {
    payload,
    type: GET_COMMENTS_FAILED,
  };
}

export function getCommentsSuccess(payload: GetCommentsSuccessType): ActionType {
  return {
    payload,
    type: GET_COMMENTS_SUCCESS,
  };
}

export function sendComment(payload: PartialCommentType): ActionType {
  return {
    payload,
    type: POST_COMMENT,
  };
}

export function sendCommentFailed(payload: unknown): ActionType {
  return {
    payload,
    type: POST_COMMENT_FAILED,
  };
}

export function sendCommentSuccess(payload: CommentType): ActionType {
  return {
    payload,
    type: POST_COMMENT_SUCCESS,
  };
}

export function updateComment(payload: PartialCommentType): ActionType {
  return {
    payload,
    type: UPDATE_COMMENT,
  };
}

export function updateCommentFailed(payload: unknown): ActionType {
  return {
    payload,
    type: UPDATE_COMMENT_FAILED,
  };
}

export function updateCommentSuccess(payload: CommentType): ActionType {
  return {
    payload,
    type: UPDATE_COMMENT_SUCCESS,
  };
}

export function deleteComment(payload: CommentType): ActionType {
  return {
    payload,
    type: DELETE_COMMENT,
  };
}

export function deleteCommentFailed(payload: unknown): ActionType {
  return {
    payload,
    type: DELETE_COMMENT_FAILED,
  };
}

export function deleteCommentSuccess(payload: CommentType): ActionType {
  return {
    payload,
    type: DELETE_COMMENT_SUCCESS,
  };
}

export function likeComment(payload: LikeCommentRequestType): ActionType {
  return {
    payload,
    type: LIKE_COMMENT,
  };
}

export function likeCommentFailed(payload: unknown): ActionType {
  return {
    payload,
    type: LIKE_COMMENT_FAILED,
  };
}

export function likeCommentSuccess(payload: string): ActionType {
  return {
    payload,
    type: LIKE_COMMENT_SUCCESS,
  };
}

export function setNtfCommentsStatus(payload: NtfCommentsRequestType): ActionType {
  return {
    payload,
    type: SET_NTF_STATUS,
  };
}

export function setNtfCommentsStatusSuccess(payload: NtfCommentsRequestType): ActionType {
  return {
    payload,
    type: SET_NTF_STATUS_SUCCESS,
  };
}

export function setNtfCommentsStatusFailed(payload: unknown): ActionType {
  return {
    payload,
    type: SET_NTF_STATUS_FAILED,
  };
}

export function updateCommentWs(payload: UpdateCommentRequestType): ActionType {
  return {
    payload,
    type: UPDATE_COMMENT_WS,
  };
}

export function getPostCommentWs(payload: NtfCommentsRequestType): ActionType {
  return {
    payload,
    type: GET_POST_COMMENT_WS,
  };
}

export function getPostCommentWsSuccess(payload: PostGetCommentType): ActionType {
  return {
    payload,
    type: GET_POST_COMMENT_WS_SUCCESS,
  };
}

export function getPostCommentWsFailed(payload: unknown): ActionType {
  return {
    payload,
    type: GET_POST_COMMENT_WS_FAILED,
  };
}

export function likePost(payload: LikePostRequestType): ActionType {
  return {
    payload,
    type: LIKE_POST,
  };
}

export function likePostSuccess(postId: string): ActionType {
  return {
    payload: postId,
    type: LIKE_POST_SUCCESS,
  };
}

export function likePostFailed(payload: unknown): ActionType {
  return {
    payload,
    type: LIKE_POST_FAILED,
  };
}
